// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/artifacts.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { EntityMeta, ErrorInfo } from "./common";

export const protobufPackage = "api.devplan.types.artifacts";

export enum ArtifactType {
  UNKNOWN_ARTIFACT = 0,
  IDEA = 1,
  REPO_SUMMARY = 2,
  COMPANY_PROFILE = 3,
  COMPETITIVE_ANALYSIS = 4,
}

export function artifactTypeFromJSON(object: any): ArtifactType {
  switch (object) {
    case 0:
    case "UNKNOWN_ARTIFACT":
      return ArtifactType.UNKNOWN_ARTIFACT;
    case 1:
    case "IDEA":
      return ArtifactType.IDEA;
    case 2:
    case "REPO_SUMMARY":
      return ArtifactType.REPO_SUMMARY;
    case 3:
    case "COMPANY_PROFILE":
      return ArtifactType.COMPANY_PROFILE;
    case 4:
    case "COMPETITIVE_ANALYSIS":
      return ArtifactType.COMPETITIVE_ANALYSIS;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ArtifactType");
  }
}

export function artifactTypeToJSON(object: ArtifactType): string {
  switch (object) {
    case ArtifactType.UNKNOWN_ARTIFACT:
      return "UNKNOWN_ARTIFACT";
    case ArtifactType.IDEA:
      return "IDEA";
    case ArtifactType.REPO_SUMMARY:
      return "REPO_SUMMARY";
    case ArtifactType.COMPANY_PROFILE:
      return "COMPANY_PROFILE";
    case ArtifactType.COMPETITIVE_ANALYSIS:
      return "COMPETITIVE_ANALYSIS";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ArtifactType");
  }
}

export enum ArtifactIdeaStatus {
  DEFAULT_IDEA_STATUS = 0,
  ARCHIVED_IDEA = 1,
}

export function artifactIdeaStatusFromJSON(object: any): ArtifactIdeaStatus {
  switch (object) {
    case 0:
    case "DEFAULT_IDEA_STATUS":
      return ArtifactIdeaStatus.DEFAULT_IDEA_STATUS;
    case 1:
    case "ARCHIVED_IDEA":
      return ArtifactIdeaStatus.ARCHIVED_IDEA;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ArtifactIdeaStatus");
  }
}

export function artifactIdeaStatusToJSON(object: ArtifactIdeaStatus): string {
  switch (object) {
    case ArtifactIdeaStatus.DEFAULT_IDEA_STATUS:
      return "DEFAULT_IDEA_STATUS";
    case ArtifactIdeaStatus.ARCHIVED_IDEA:
      return "ARCHIVED_IDEA";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ArtifactIdeaStatus");
  }
}

export enum SpecType {
  UNKNOWN_SPEC = 0,
  RESEARCH = 1,
  PLAN = 2,
  CODE = 3,
  REVIEW = 4,
  IMPL_ANALYSIS = 5,
}

export function specTypeFromJSON(object: any): SpecType {
  switch (object) {
    case 0:
    case "UNKNOWN_SPEC":
      return SpecType.UNKNOWN_SPEC;
    case 1:
    case "RESEARCH":
      return SpecType.RESEARCH;
    case 2:
    case "PLAN":
      return SpecType.PLAN;
    case 3:
    case "CODE":
      return SpecType.CODE;
    case 4:
    case "REVIEW":
      return SpecType.REVIEW;
    case 5:
    case "IMPL_ANALYSIS":
      return SpecType.IMPL_ANALYSIS;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum SpecType");
  }
}

export function specTypeToJSON(object: SpecType): string {
  switch (object) {
    case SpecType.UNKNOWN_SPEC:
      return "UNKNOWN_SPEC";
    case SpecType.RESEARCH:
      return "RESEARCH";
    case SpecType.PLAN:
      return "PLAN";
    case SpecType.CODE:
      return "CODE";
    case SpecType.REVIEW:
      return "REVIEW";
    case SpecType.IMPL_ANALYSIS:
      return "IMPL_ANALYSIS";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum SpecType");
  }
}

export interface ArtifactMeta {
  companyId: number;
  type: ArtifactType;
}

export interface ArtifactIdea {
  id: string;
  meta: EntityMeta | undefined;
  title: string;
  description: string;
  status: ArtifactIdeaStatus;
  artifactMeta:
    | ArtifactMeta
    | undefined;
  /** References to Tag.id */
  tagIds: string[];
}

export interface ArtifactRepoSummary {
  id: string;
  meta: EntityMeta | undefined;
  summary?: RepoSummary | undefined;
  repoId: string;
  error?: ErrorInfo | undefined;
  artifactMeta: ArtifactMeta | undefined;
  repoName: string;
}

export interface ResearchSource {
  url: string;
  title: string;
  publisher: string;
  publishedAt: Date | undefined;
  evidence: string;
}

export interface ArtifactCompanyProfile {
  companyName: string;
  websiteUrl: string;
  overview: string;
  products: string[];
  targetCustomers: string[];
  industries: string[];
  positioning: string;
  uncertainties: string[];
  sources: ResearchSource[];
  id: string;
  meta: EntityMeta | undefined;
  artifactMeta: ArtifactMeta | undefined;
}

export interface Competitor {
  name: string;
  websiteUrl: string;
  productOverlap: string;
  differentiation: string;
  sources: ResearchSource[];
}

export interface ArtifactCompetitiveAnalysis {
  companyName: string;
  marketFraming: string;
  competitors: Competitor[];
  productAlignment: string[];
  differentiation: string[];
  implications: string[];
  uncertainties: string[];
  sources: ResearchSource[];
  id: string;
  meta: EntityMeta | undefined;
  artifactMeta: ArtifactMeta | undefined;
}

export interface ArtifactsList {
  id: string;
  companyId: number;
  orderedIds: string[];
}

export interface RepoSummary {
  content: string;
}

export interface RepoSummaryResult {
  type: { $case: "summary"; value: RepoSummary } | { $case: "error"; value: string } | undefined;
}

export interface SpecDetails {
  id: string;
  type: SpecType;
  checksum: string;
  size: number;
  name: string;
  taskId?: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  uploadPath: string;
  companyId: number;
}

export interface SpecPathsInfo {
  companyId: number;
  specsRoot: string;
  taskPaths: { [key: string]: SpecPathInfo };
}

export interface SpecPathsInfo_TaskPathsEntry {
  key: string;
  value: SpecPathInfo | undefined;
}

export interface SpecPathInfo {
  taskDir: string;
}

function createBaseArtifactMeta(): ArtifactMeta {
  return { companyId: 0, type: 0 };
}

export const ArtifactMeta: MessageFns<ArtifactMeta> = {
  encode(message: ArtifactMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactMeta {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      type: isSet(object.type) ? artifactTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: ArtifactMeta): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.type !== 0) {
      obj.type = artifactTypeToJSON(message.type);
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactMeta>): ArtifactMeta {
    return ArtifactMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactMeta>): ArtifactMeta {
    const message = createBaseArtifactMeta();
    message.companyId = object.companyId ?? 0;
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseArtifactIdea(): ArtifactIdea {
  return { id: "", meta: undefined, title: "", description: "", status: 0, artifactMeta: undefined, tagIds: [] };
}

export const ArtifactIdea: MessageFns<ArtifactIdea> = {
  encode(message: ArtifactIdea, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.artifactMeta !== undefined) {
      ArtifactMeta.encode(message.artifactMeta, writer.uint32(50).fork()).join();
    }
    for (const v of message.tagIds) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactIdea {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactIdea();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.artifactMeta = ArtifactMeta.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tagIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactIdea {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      status: isSet(object.status) ? artifactIdeaStatusFromJSON(object.status) : 0,
      artifactMeta: isSet(object.artifactMeta)
        ? ArtifactMeta.fromJSON(object.artifactMeta)
        : isSet(object.artifact_meta)
        ? ArtifactMeta.fromJSON(object.artifact_meta)
        : undefined,
      tagIds: globalThis.Array.isArray(object?.tagIds)
        ? object.tagIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.tag_ids)
        ? object.tag_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ArtifactIdea): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.status !== 0) {
      obj.status = artifactIdeaStatusToJSON(message.status);
    }
    if (message.artifactMeta !== undefined) {
      obj.artifactMeta = ArtifactMeta.toJSON(message.artifactMeta);
    }
    if (message.tagIds?.length) {
      obj.tagIds = message.tagIds;
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactIdea>): ArtifactIdea {
    return ArtifactIdea.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactIdea>): ArtifactIdea {
    const message = createBaseArtifactIdea();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.status = object.status ?? 0;
    message.artifactMeta = (object.artifactMeta !== undefined && object.artifactMeta !== null)
      ? ArtifactMeta.fromPartial(object.artifactMeta)
      : undefined;
    message.tagIds = object.tagIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseArtifactRepoSummary(): ArtifactRepoSummary {
  return {
    id: "",
    meta: undefined,
    summary: undefined,
    repoId: "",
    error: undefined,
    artifactMeta: undefined,
    repoName: "",
  };
}

export const ArtifactRepoSummary: MessageFns<ArtifactRepoSummary> = {
  encode(message: ArtifactRepoSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.summary !== undefined) {
      RepoSummary.encode(message.summary, writer.uint32(26).fork()).join();
    }
    if (message.repoId !== "") {
      writer.uint32(34).string(message.repoId);
    }
    if (message.error !== undefined) {
      ErrorInfo.encode(message.error, writer.uint32(42).fork()).join();
    }
    if (message.artifactMeta !== undefined) {
      ArtifactMeta.encode(message.artifactMeta, writer.uint32(50).fork()).join();
    }
    if (message.repoName !== "") {
      writer.uint32(58).string(message.repoName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactRepoSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactRepoSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.summary = RepoSummary.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.error = ErrorInfo.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.artifactMeta = ArtifactMeta.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.repoName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactRepoSummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      summary: isSet(object.summary) ? RepoSummary.fromJSON(object.summary) : undefined,
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
      error: isSet(object.error) ? ErrorInfo.fromJSON(object.error) : undefined,
      artifactMeta: isSet(object.artifactMeta)
        ? ArtifactMeta.fromJSON(object.artifactMeta)
        : isSet(object.artifact_meta)
        ? ArtifactMeta.fromJSON(object.artifact_meta)
        : undefined,
      repoName: isSet(object.repoName)
        ? globalThis.String(object.repoName)
        : isSet(object.repo_name)
        ? globalThis.String(object.repo_name)
        : "",
    };
  },

  toJSON(message: ArtifactRepoSummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.summary !== undefined) {
      obj.summary = RepoSummary.toJSON(message.summary);
    }
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    if (message.error !== undefined) {
      obj.error = ErrorInfo.toJSON(message.error);
    }
    if (message.artifactMeta !== undefined) {
      obj.artifactMeta = ArtifactMeta.toJSON(message.artifactMeta);
    }
    if (message.repoName !== "") {
      obj.repoName = message.repoName;
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactRepoSummary>): ArtifactRepoSummary {
    return ArtifactRepoSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactRepoSummary>): ArtifactRepoSummary {
    const message = createBaseArtifactRepoSummary();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.summary = (object.summary !== undefined && object.summary !== null)
      ? RepoSummary.fromPartial(object.summary)
      : undefined;
    message.repoId = object.repoId ?? "";
    message.error = (object.error !== undefined && object.error !== null)
      ? ErrorInfo.fromPartial(object.error)
      : undefined;
    message.artifactMeta = (object.artifactMeta !== undefined && object.artifactMeta !== null)
      ? ArtifactMeta.fromPartial(object.artifactMeta)
      : undefined;
    message.repoName = object.repoName ?? "";
    return message;
  },
};

function createBaseResearchSource(): ResearchSource {
  return { url: "", title: "", publisher: "", publishedAt: undefined, evidence: "" };
}

export const ResearchSource: MessageFns<ResearchSource> = {
  encode(message: ResearchSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.publisher !== "") {
      writer.uint32(26).string(message.publisher);
    }
    if (message.publishedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.publishedAt), writer.uint32(34).fork()).join();
    }
    if (message.evidence !== "") {
      writer.uint32(42).string(message.evidence);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResearchSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.publisher = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.publishedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.evidence = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResearchSource {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      publisher: isSet(object.publisher) ? globalThis.String(object.publisher) : "",
      publishedAt: isSet(object.publishedAt)
        ? fromJsonTimestamp(object.publishedAt)
        : isSet(object.published_at)
        ? fromJsonTimestamp(object.published_at)
        : undefined,
      evidence: isSet(object.evidence) ? globalThis.String(object.evidence) : "",
    };
  },

  toJSON(message: ResearchSource): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.publisher !== "") {
      obj.publisher = message.publisher;
    }
    if (message.publishedAt !== undefined) {
      obj.publishedAt = message.publishedAt.toISOString();
    }
    if (message.evidence !== "") {
      obj.evidence = message.evidence;
    }
    return obj;
  },

  create(base?: DeepPartial<ResearchSource>): ResearchSource {
    return ResearchSource.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ResearchSource>): ResearchSource {
    const message = createBaseResearchSource();
    message.url = object.url ?? "";
    message.title = object.title ?? "";
    message.publisher = object.publisher ?? "";
    message.publishedAt = object.publishedAt ?? undefined;
    message.evidence = object.evidence ?? "";
    return message;
  },
};

function createBaseArtifactCompanyProfile(): ArtifactCompanyProfile {
  return {
    companyName: "",
    websiteUrl: "",
    overview: "",
    products: [],
    targetCustomers: [],
    industries: [],
    positioning: "",
    uncertainties: [],
    sources: [],
    id: "",
    meta: undefined,
    artifactMeta: undefined,
  };
}

export const ArtifactCompanyProfile: MessageFns<ArtifactCompanyProfile> = {
  encode(message: ArtifactCompanyProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyName !== "") {
      writer.uint32(10).string(message.companyName);
    }
    if (message.websiteUrl !== "") {
      writer.uint32(18).string(message.websiteUrl);
    }
    if (message.overview !== "") {
      writer.uint32(26).string(message.overview);
    }
    for (const v of message.products) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.targetCustomers) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.industries) {
      writer.uint32(50).string(v!);
    }
    if (message.positioning !== "") {
      writer.uint32(58).string(message.positioning);
    }
    for (const v of message.uncertainties) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.sources) {
      ResearchSource.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(82).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(90).fork()).join();
    }
    if (message.artifactMeta !== undefined) {
      ArtifactMeta.encode(message.artifactMeta, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactCompanyProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactCompanyProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.companyName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.websiteUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.overview = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.products.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetCustomers.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.industries.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.positioning = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.uncertainties.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sources.push(ResearchSource.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.artifactMeta = ArtifactMeta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactCompanyProfile {
    return {
      companyName: isSet(object.companyName)
        ? globalThis.String(object.companyName)
        : isSet(object.company_name)
        ? globalThis.String(object.company_name)
        : "",
      websiteUrl: isSet(object.websiteUrl)
        ? globalThis.String(object.websiteUrl)
        : isSet(object.website_url)
        ? globalThis.String(object.website_url)
        : "",
      overview: isSet(object.overview) ? globalThis.String(object.overview) : "",
      products: globalThis.Array.isArray(object?.products) ? object.products.map((e: any) => globalThis.String(e)) : [],
      targetCustomers: globalThis.Array.isArray(object?.targetCustomers)
        ? object.targetCustomers.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.target_customers)
        ? object.target_customers.map((e: any) => globalThis.String(e))
        : [],
      industries: globalThis.Array.isArray(object?.industries)
        ? object.industries.map((e: any) => globalThis.String(e))
        : [],
      positioning: isSet(object.positioning) ? globalThis.String(object.positioning) : "",
      uncertainties: globalThis.Array.isArray(object?.uncertainties)
        ? object.uncertainties.map((e: any) => globalThis.String(e))
        : [],
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => ResearchSource.fromJSON(e))
        : [],
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      artifactMeta: isSet(object.artifactMeta)
        ? ArtifactMeta.fromJSON(object.artifactMeta)
        : isSet(object.artifact_meta)
        ? ArtifactMeta.fromJSON(object.artifact_meta)
        : undefined,
    };
  },

  toJSON(message: ArtifactCompanyProfile): unknown {
    const obj: any = {};
    if (message.companyName !== "") {
      obj.companyName = message.companyName;
    }
    if (message.websiteUrl !== "") {
      obj.websiteUrl = message.websiteUrl;
    }
    if (message.overview !== "") {
      obj.overview = message.overview;
    }
    if (message.products?.length) {
      obj.products = message.products;
    }
    if (message.targetCustomers?.length) {
      obj.targetCustomers = message.targetCustomers;
    }
    if (message.industries?.length) {
      obj.industries = message.industries;
    }
    if (message.positioning !== "") {
      obj.positioning = message.positioning;
    }
    if (message.uncertainties?.length) {
      obj.uncertainties = message.uncertainties;
    }
    if (message.sources?.length) {
      obj.sources = message.sources.map((e) => ResearchSource.toJSON(e));
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.artifactMeta !== undefined) {
      obj.artifactMeta = ArtifactMeta.toJSON(message.artifactMeta);
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactCompanyProfile>): ArtifactCompanyProfile {
    return ArtifactCompanyProfile.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactCompanyProfile>): ArtifactCompanyProfile {
    const message = createBaseArtifactCompanyProfile();
    message.companyName = object.companyName ?? "";
    message.websiteUrl = object.websiteUrl ?? "";
    message.overview = object.overview ?? "";
    message.products = object.products?.map((e) => e) || [];
    message.targetCustomers = object.targetCustomers?.map((e) => e) || [];
    message.industries = object.industries?.map((e) => e) || [];
    message.positioning = object.positioning ?? "";
    message.uncertainties = object.uncertainties?.map((e) => e) || [];
    message.sources = object.sources?.map((e) => ResearchSource.fromPartial(e)) || [];
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.artifactMeta = (object.artifactMeta !== undefined && object.artifactMeta !== null)
      ? ArtifactMeta.fromPartial(object.artifactMeta)
      : undefined;
    return message;
  },
};

function createBaseCompetitor(): Competitor {
  return { name: "", websiteUrl: "", productOverlap: "", differentiation: "", sources: [] };
}

export const Competitor: MessageFns<Competitor> = {
  encode(message: Competitor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.websiteUrl !== "") {
      writer.uint32(18).string(message.websiteUrl);
    }
    if (message.productOverlap !== "") {
      writer.uint32(26).string(message.productOverlap);
    }
    if (message.differentiation !== "") {
      writer.uint32(34).string(message.differentiation);
    }
    for (const v of message.sources) {
      ResearchSource.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Competitor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompetitor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.websiteUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.productOverlap = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.differentiation = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sources.push(ResearchSource.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Competitor {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      websiteUrl: isSet(object.websiteUrl)
        ? globalThis.String(object.websiteUrl)
        : isSet(object.website_url)
        ? globalThis.String(object.website_url)
        : "",
      productOverlap: isSet(object.productOverlap)
        ? globalThis.String(object.productOverlap)
        : isSet(object.product_overlap)
        ? globalThis.String(object.product_overlap)
        : "",
      differentiation: isSet(object.differentiation) ? globalThis.String(object.differentiation) : "",
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => ResearchSource.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Competitor): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.websiteUrl !== "") {
      obj.websiteUrl = message.websiteUrl;
    }
    if (message.productOverlap !== "") {
      obj.productOverlap = message.productOverlap;
    }
    if (message.differentiation !== "") {
      obj.differentiation = message.differentiation;
    }
    if (message.sources?.length) {
      obj.sources = message.sources.map((e) => ResearchSource.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Competitor>): Competitor {
    return Competitor.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Competitor>): Competitor {
    const message = createBaseCompetitor();
    message.name = object.name ?? "";
    message.websiteUrl = object.websiteUrl ?? "";
    message.productOverlap = object.productOverlap ?? "";
    message.differentiation = object.differentiation ?? "";
    message.sources = object.sources?.map((e) => ResearchSource.fromPartial(e)) || [];
    return message;
  },
};

function createBaseArtifactCompetitiveAnalysis(): ArtifactCompetitiveAnalysis {
  return {
    companyName: "",
    marketFraming: "",
    competitors: [],
    productAlignment: [],
    differentiation: [],
    implications: [],
    uncertainties: [],
    sources: [],
    id: "",
    meta: undefined,
    artifactMeta: undefined,
  };
}

export const ArtifactCompetitiveAnalysis: MessageFns<ArtifactCompetitiveAnalysis> = {
  encode(message: ArtifactCompetitiveAnalysis, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyName !== "") {
      writer.uint32(10).string(message.companyName);
    }
    if (message.marketFraming !== "") {
      writer.uint32(18).string(message.marketFraming);
    }
    for (const v of message.competitors) {
      Competitor.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.productAlignment) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.differentiation) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.implications) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.uncertainties) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.sources) {
      ResearchSource.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(74).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(82).fork()).join();
    }
    if (message.artifactMeta !== undefined) {
      ArtifactMeta.encode(message.artifactMeta, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactCompetitiveAnalysis {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactCompetitiveAnalysis();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.companyName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.marketFraming = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.competitors.push(Competitor.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.productAlignment.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.differentiation.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.implications.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.uncertainties.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.sources.push(ResearchSource.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.artifactMeta = ArtifactMeta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactCompetitiveAnalysis {
    return {
      companyName: isSet(object.companyName)
        ? globalThis.String(object.companyName)
        : isSet(object.company_name)
        ? globalThis.String(object.company_name)
        : "",
      marketFraming: isSet(object.marketFraming)
        ? globalThis.String(object.marketFraming)
        : isSet(object.market_framing)
        ? globalThis.String(object.market_framing)
        : "",
      competitors: globalThis.Array.isArray(object?.competitors)
        ? object.competitors.map((e: any) => Competitor.fromJSON(e))
        : [],
      productAlignment: globalThis.Array.isArray(object?.productAlignment)
        ? object.productAlignment.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_alignment)
        ? object.product_alignment.map((e: any) => globalThis.String(e))
        : [],
      differentiation: globalThis.Array.isArray(object?.differentiation)
        ? object.differentiation.map((e: any) => globalThis.String(e))
        : [],
      implications: globalThis.Array.isArray(object?.implications)
        ? object.implications.map((e: any) => globalThis.String(e))
        : [],
      uncertainties: globalThis.Array.isArray(object?.uncertainties)
        ? object.uncertainties.map((e: any) => globalThis.String(e))
        : [],
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => ResearchSource.fromJSON(e))
        : [],
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      artifactMeta: isSet(object.artifactMeta)
        ? ArtifactMeta.fromJSON(object.artifactMeta)
        : isSet(object.artifact_meta)
        ? ArtifactMeta.fromJSON(object.artifact_meta)
        : undefined,
    };
  },

  toJSON(message: ArtifactCompetitiveAnalysis): unknown {
    const obj: any = {};
    if (message.companyName !== "") {
      obj.companyName = message.companyName;
    }
    if (message.marketFraming !== "") {
      obj.marketFraming = message.marketFraming;
    }
    if (message.competitors?.length) {
      obj.competitors = message.competitors.map((e) => Competitor.toJSON(e));
    }
    if (message.productAlignment?.length) {
      obj.productAlignment = message.productAlignment;
    }
    if (message.differentiation?.length) {
      obj.differentiation = message.differentiation;
    }
    if (message.implications?.length) {
      obj.implications = message.implications;
    }
    if (message.uncertainties?.length) {
      obj.uncertainties = message.uncertainties;
    }
    if (message.sources?.length) {
      obj.sources = message.sources.map((e) => ResearchSource.toJSON(e));
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.artifactMeta !== undefined) {
      obj.artifactMeta = ArtifactMeta.toJSON(message.artifactMeta);
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactCompetitiveAnalysis>): ArtifactCompetitiveAnalysis {
    return ArtifactCompetitiveAnalysis.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactCompetitiveAnalysis>): ArtifactCompetitiveAnalysis {
    const message = createBaseArtifactCompetitiveAnalysis();
    message.companyName = object.companyName ?? "";
    message.marketFraming = object.marketFraming ?? "";
    message.competitors = object.competitors?.map((e) => Competitor.fromPartial(e)) || [];
    message.productAlignment = object.productAlignment?.map((e) => e) || [];
    message.differentiation = object.differentiation?.map((e) => e) || [];
    message.implications = object.implications?.map((e) => e) || [];
    message.uncertainties = object.uncertainties?.map((e) => e) || [];
    message.sources = object.sources?.map((e) => ResearchSource.fromPartial(e)) || [];
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.artifactMeta = (object.artifactMeta !== undefined && object.artifactMeta !== null)
      ? ArtifactMeta.fromPartial(object.artifactMeta)
      : undefined;
    return message;
  },
};

function createBaseArtifactsList(): ArtifactsList {
  return { id: "", companyId: 0, orderedIds: [] };
}

export const ArtifactsList: MessageFns<ArtifactsList> = {
  encode(message: ArtifactsList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    for (const v of message.orderedIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactsList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactsList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orderedIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactsList {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      orderedIds: globalThis.Array.isArray(object?.orderedIds)
        ? object.orderedIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ordered_ids)
        ? object.ordered_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ArtifactsList): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.orderedIds?.length) {
      obj.orderedIds = message.orderedIds;
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactsList>): ArtifactsList {
    return ArtifactsList.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactsList>): ArtifactsList {
    const message = createBaseArtifactsList();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.orderedIds = object.orderedIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseRepoSummary(): RepoSummary {
  return { content: "" };
}

export const RepoSummary: MessageFns<RepoSummary> = {
  encode(message: RepoSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.content !== "") {
      writer.uint32(10).string(message.content);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.content = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoSummary {
    return { content: isSet(object.content) ? globalThis.String(object.content) : "" };
  },

  toJSON(message: RepoSummary): unknown {
    const obj: any = {};
    if (message.content !== "") {
      obj.content = message.content;
    }
    return obj;
  },

  create(base?: DeepPartial<RepoSummary>): RepoSummary {
    return RepoSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoSummary>): RepoSummary {
    const message = createBaseRepoSummary();
    message.content = object.content ?? "";
    return message;
  },
};

function createBaseRepoSummaryResult(): RepoSummaryResult {
  return { type: undefined };
}

export const RepoSummaryResult: MessageFns<RepoSummaryResult> = {
  encode(message: RepoSummaryResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.type?.$case) {
      case "summary":
        RepoSummary.encode(message.type.value, writer.uint32(10).fork()).join();
        break;
      case "error":
        writer.uint32(18).string(message.type.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoSummaryResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoSummaryResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = { $case: "summary", value: RepoSummary.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.type = { $case: "error", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoSummaryResult {
    return {
      type: isSet(object.summary)
        ? { $case: "summary", value: RepoSummary.fromJSON(object.summary) }
        : isSet(object.error)
        ? { $case: "error", value: globalThis.String(object.error) }
        : undefined,
    };
  },

  toJSON(message: RepoSummaryResult): unknown {
    const obj: any = {};
    if (message.type?.$case === "summary") {
      obj.summary = RepoSummary.toJSON(message.type.value);
    } else if (message.type?.$case === "error") {
      obj.error = message.type.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RepoSummaryResult>): RepoSummaryResult {
    return RepoSummaryResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoSummaryResult>): RepoSummaryResult {
    const message = createBaseRepoSummaryResult();
    switch (object.type?.$case) {
      case "summary": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "summary", value: RepoSummary.fromPartial(object.type.value) };
        }
        break;
      }
      case "error": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "error", value: object.type.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseSpecDetails(): SpecDetails {
  return {
    id: "",
    type: 0,
    checksum: "",
    size: 0,
    name: "",
    taskId: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    uploadPath: "",
    companyId: 0,
  };
}

export const SpecDetails: MessageFns<SpecDetails> = {
  encode(message: SpecDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.checksum !== "") {
      writer.uint32(26).string(message.checksum);
    }
    if (message.size !== 0) {
      writer.uint32(32).int64(message.size);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.taskId !== undefined) {
      writer.uint32(50).string(message.taskId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    if (message.uploadPath !== "") {
      writer.uint32(74).string(message.uploadPath);
    }
    if (message.companyId !== 0) {
      writer.uint32(80).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpecDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.checksum = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.size = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.uploadPath = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpecDetails {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? specTypeFromJSON(object.type) : 0,
      checksum: isSet(object.checksum) ? globalThis.String(object.checksum) : "",
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      taskId: isSet(object.taskId)
        ? globalThis.String(object.taskId)
        : isSet(object.task_id)
        ? globalThis.String(object.task_id)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      uploadPath: isSet(object.uploadPath)
        ? globalThis.String(object.uploadPath)
        : isSet(object.upload_path)
        ? globalThis.String(object.upload_path)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: SpecDetails): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== 0) {
      obj.type = specTypeToJSON(message.type);
    }
    if (message.checksum !== "") {
      obj.checksum = message.checksum;
    }
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.taskId !== undefined) {
      obj.taskId = message.taskId;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.uploadPath !== "") {
      obj.uploadPath = message.uploadPath;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<SpecDetails>): SpecDetails {
    return SpecDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SpecDetails>): SpecDetails {
    const message = createBaseSpecDetails();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    message.checksum = object.checksum ?? "";
    message.size = object.size ?? 0;
    message.name = object.name ?? "";
    message.taskId = object.taskId ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.uploadPath = object.uploadPath ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseSpecPathsInfo(): SpecPathsInfo {
  return { companyId: 0, specsRoot: "", taskPaths: {} };
}

export const SpecPathsInfo: MessageFns<SpecPathsInfo> = {
  encode(message: SpecPathsInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.specsRoot !== "") {
      writer.uint32(18).string(message.specsRoot);
    }
    globalThis.Object.entries(message.taskPaths).forEach(([key, value]: [string, SpecPathInfo]) => {
      SpecPathsInfo_TaskPathsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpecPathsInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecPathsInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.specsRoot = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = SpecPathsInfo_TaskPathsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.taskPaths[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpecPathsInfo {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      specsRoot: isSet(object.specsRoot)
        ? globalThis.String(object.specsRoot)
        : isSet(object.specs_root)
        ? globalThis.String(object.specs_root)
        : "",
      taskPaths: isObject(object.taskPaths)
        ? (globalThis.Object.entries(object.taskPaths) as [string, any][]).reduce(
          (acc: { [key: string]: SpecPathInfo }, [key, value]: [string, any]) => {
            acc[key] = SpecPathInfo.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.task_paths)
        ? (globalThis.Object.entries(object.task_paths) as [string, any][]).reduce(
          (acc: { [key: string]: SpecPathInfo }, [key, value]: [string, any]) => {
            acc[key] = SpecPathInfo.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: SpecPathsInfo): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.specsRoot !== "") {
      obj.specsRoot = message.specsRoot;
    }
    if (message.taskPaths) {
      const entries = globalThis.Object.entries(message.taskPaths) as [string, SpecPathInfo][];
      if (entries.length > 0) {
        obj.taskPaths = {};
        entries.forEach(([k, v]) => {
          obj.taskPaths[k] = SpecPathInfo.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<SpecPathsInfo>): SpecPathsInfo {
    return SpecPathsInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SpecPathsInfo>): SpecPathsInfo {
    const message = createBaseSpecPathsInfo();
    message.companyId = object.companyId ?? 0;
    message.specsRoot = object.specsRoot ?? "";
    message.taskPaths = (globalThis.Object.entries(object.taskPaths ?? {}) as [string, SpecPathInfo][]).reduce(
      (acc: { [key: string]: SpecPathInfo }, [key, value]: [string, SpecPathInfo]) => {
        if (value !== undefined) {
          acc[key] = SpecPathInfo.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseSpecPathsInfo_TaskPathsEntry(): SpecPathsInfo_TaskPathsEntry {
  return { key: "", value: undefined };
}

export const SpecPathsInfo_TaskPathsEntry: MessageFns<SpecPathsInfo_TaskPathsEntry> = {
  encode(message: SpecPathsInfo_TaskPathsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      SpecPathInfo.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpecPathsInfo_TaskPathsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecPathsInfo_TaskPathsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = SpecPathInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpecPathsInfo_TaskPathsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? SpecPathInfo.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: SpecPathsInfo_TaskPathsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = SpecPathInfo.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<SpecPathsInfo_TaskPathsEntry>): SpecPathsInfo_TaskPathsEntry {
    return SpecPathsInfo_TaskPathsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SpecPathsInfo_TaskPathsEntry>): SpecPathsInfo_TaskPathsEntry {
    const message = createBaseSpecPathsInfo_TaskPathsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? SpecPathInfo.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseSpecPathInfo(): SpecPathInfo {
  return { taskDir: "" };
}

export const SpecPathInfo: MessageFns<SpecPathInfo> = {
  encode(message: SpecPathInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskDir !== "") {
      writer.uint32(10).string(message.taskDir);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpecPathInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecPathInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.taskDir = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpecPathInfo {
    return {
      taskDir: isSet(object.taskDir)
        ? globalThis.String(object.taskDir)
        : isSet(object.task_dir)
        ? globalThis.String(object.task_dir)
        : "",
    };
  },

  toJSON(message: SpecPathInfo): unknown {
    const obj: any = {};
    if (message.taskDir !== "") {
      obj.taskDir = message.taskDir;
    }
    return obj;
  },

  create(base?: DeepPartial<SpecPathInfo>): SpecPathInfo {
    return SpecPathInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SpecPathInfo>): SpecPathInfo {
    const message = createBaseSpecPathInfo();
    message.taskDir = object.taskDir ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
